import { render, staticRenderFns } from "./bo-cell-link.vue?vue&type=template&id=ad397f64"
import script from "./bo-cell-link.vue?vue&type=script&lang=js"
export * from "./bo-cell-link.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports